module.exports = __webpack_public_path__ + "static/img/share.0c97398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestival/dialog/share.png
// module id = xaoV
// module chunks = 1